import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CELL_PADDING } from "components/common/EntityDataTable/Constants";
const useActionsColumnWidth = (entities, hasRowActions) => {
  const [rowWidths, setRowWidths] = useState({});
  const visibleRowIds = useMemo(() => new Set(entities.map(({ id }) => id)), [entities]);
  const visibleRowIdsRef = useRef(visibleRowIds);
  useEffect(() => {
    visibleRowIdsRef.current = visibleRowIds;
  }, [visibleRowIds]);
  const handleWidthChange = useCallback((rowId, width) => {
    const rounded = Math.round(width);
    if (rounded <= 0 || !visibleRowIdsRef.current.has(rowId)) {
      return;
    }
    setRowWidths((cur) => cur[rowId] === rounded ? cur : { ...cur, [rowId]: rounded });
  }, []);
  const colMinWidth = useMemo(() => {
    if (!visibleRowIds.size) {
      return CELL_PADDING * 2;
    }
    const maxWidth = Math.max(
      0,
      ...Array.from(visibleRowIds).map((rowId) => rowWidths[rowId]).filter((width) => !!width)
    );
    return hasRowActions ? maxWidth + CELL_PADDING * 2 : 0;
  }, [hasRowActions, rowWidths, visibleRowIds]);
  return { colMinWidth, handleWidthChange };
};
export default useActionsColumnWidth;
